import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  SortingState,
  IntegratedSorting,
  FilteringState,
  IntegratedFiltering,
  RowDetailState,
  DataTypeProvider,
} from '@devexpress/dx-react-grid'
import {
  Grid,
  VirtualTable,
  TableHeaderRow,
  TableFilterRow,
  TableRowDetail,
} from '@devexpress/dx-react-grid-material-ui';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';

import StringTypeProvider from './data_type_provider/StringTypeProvider.js';
import PhoneFormat from './format/PhoneFormat.js';

import firebase from 'firebase/app';

import moment from 'moment';

require("moment-duration-format");
require("firebase/firestore");

const styles = theme => ({
});

const getRowId = row => row.id;

const columns = [
  { name: 'name', title: 'Name' },
  { name: 'phone', title: 'Phone' },
  { name: 'room', title: 'Room' },
  { name: 'bookingStartTime', title: 'Start Time' },
  { name: 'bookingEndTime', title: 'End Time' },
  { name: 'duration', title: 'Duration' },
  { name: 'bookingCreateTime', title: 'Book on' },
  { name: 'statusDesc', title: 'Status' },
];
const columnExtensions = [
  { columnName: 'name', width: 200 },
  { columnName: 'phone', width: 80 },
  { columnName: 'room', width: 120 },
  { columnName: 'bookingStartTime', width: 160 },
  { columnName: 'bookingEndTime', width: 160 },
  { columnName: 'duration', width: 70 },
  { columnName: 'bookingCreateTime', width: 160 },
];

const PhoneTypeProvider = () => (
  <DataTypeProvider
    for={['phone']}
    formatterComponent={({ value }) => <PhoneFormat displayType='text' value={value} /> }
    editorComponent={({ value, onValueChange }) =>
      <TextField value={value !== null ? value : ''} onChange={event => onValueChange(event.target.value)} />
    }
  />
);

const DateTypeProvider = () => (
  <DataTypeProvider
    for={['bookingStartTime', 'bookingEndTime', 'bookingCreateTime']}
    formatterComponent={({ value }) => value ? moment(value).format('lll') : ''}
    editorComponent={({ value, onValueChange }) =>
      <TextField value={value !== null ? value : ''} onChange={event => onValueChange(event.target.value)} />
    }
  />
);

const detailRowTemplate = ({ row }) => <div>id: {row.id}</div>;

class RoomHistoryTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],

      width: window.innerWidth,
      height: window.innerHeight,

      unsubscribeBookings: null,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  queryBookings = (date) => {
    var from = moment(date);
    from.second(0);
    from.minute(0);
    from.hour(0);
    var to = moment(date);
    to.second(59);
    to.minute(59);
    to.hour(23);

    return firebase.firestore()
      .collection("bookings")
      .where('bookingStartTime', '>=', from.toDate())
      .where('bookingStartTime', '<=', to.toDate())
      .onSnapshot(function(querySnapshot) {
        var rows = this.state.rows;
        querySnapshot.docChanges().forEach(change => {
          if (change.type === "added" || change.type === "modified") {
            let data = change.doc.data();
            data.id =  change.doc.id;

            if (data.bookingStartTime && data.bookingEndTime) {
              data.duration = moment.duration(moment(data.bookingEndTime).diff(data.bookingStartTime)).format("h:mm:ss", { trim: false });
            }
            if (data.status) {
              var statusDesc = this.props.bookingStatus.find(status => {return status.id === data.status.toString()});
              data.statusDesc = statusDesc && statusDesc.message;
            }
            if (data.roomId) {
              var room = this.props.rooms.find(room => {return room.id === data.roomId});
              data.room = room && room.name;
            }

            let index = rows.findIndex(element => {
              return element.id === data.id;
            });
            if (index === -1) {
              rows.push(data);
            } else {
              rows[index] = data;
            }
          }
        });
        this.setState({
          rows: Array.from(rows),
        });

        rows.forEach(row => {
          this.getUserInfo(row.id, row.userId);
        });
      }.bind(this));
  }

  getUserInfo = (rowId, userId) => {
    firebase.firestore()
      .collection("users")
      .doc(userId)
      .get()
      .then((doc) => {
        if (doc.exists) {
          var rows = this.state.rows;
          var index = rows.findIndex(row => {return row.id === rowId});
          if (index !== -1) {
            rows[index].name = doc.data().name;
            rows[index].phone = doc.data().phone;
          }
          this.setState({
            rows: Array.from(rows),
          });
        }
      });
  }

  getRoomName = (rooms) => {
    if (rooms && rooms.length > 0) {
      var rows = this.state.rows;
      rows.forEach((row, index) => {
        if (row.roomId) {
          var found = rooms.find(room => {return room.id === row.roomId});
          row.room = (found && found.name) || '';
          rows[index] = row;
        }
      });
      this.setState({
        rows: Array.from(rows),
      });
    }
  }

  getStatusDesc = (bookingStatus) => {
    if (bookingStatus && bookingStatus.length > 0) {
      var rows = this.state.rows;
      rows.forEach((row, index) => {
        if (row.status) {
          var found = bookingStatus.find(status => {return status.id === row.status.toString()});
          row.statusDesc = (found && found.message) || '';
          rows[index] = row;
        }
      });
      this.setState({
        rows: Array.from(rows),
      });
    }
  }

  startQuery(date) {
    this.setState({
      rows: [],
      unsubscribeBookings: this.queryBookings(date),
    });
  }

  stopQuery() {
    this.state.unsubscribeBookings && this.state.unsubscribeBookings();
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    this.startQuery(this.props.date);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
    this.stopQuery();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.bookingStatus.length !== nextProps.bookingStatus.length && nextProps.bookingStatus.length > 0) {
      this.getStatusDesc(nextProps.bookingStatus);
    }
    if (this.props.rooms.length !== nextProps.rooms.length && nextProps.rooms.length > 0) {
      this.getRoomName(nextProps.rooms);
    }

    if (this.props.date !== nextProps.date) {
      this.stopQuery();
      this.startQuery(nextProps.date);
    }
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    // const { classes } = this.props;
    return(
      <Paper>
        <Grid
          rows={this.state.rows}
          getRowId={getRowId}
          columns={columns}>

          <PhoneTypeProvider />
          <DateTypeProvider />
          <StringTypeProvider for={['name', 'room', 'duration', 'statusDesc']} />

          <RowDetailState />

          {/* Sorting */}
          <SortingState defaultSorting={[ {columnName: 'checkInTime', direction: 'desc'}, ]}/>
          <IntegratedSorting />

          {/* Filter */}
          <FilteringState />
          <IntegratedFiltering />

          <VirtualTable
            columnExtensions={columnExtensions}
            height={this.state.height - 112} />
          <TableHeaderRow showSortingControls />
          <TableFilterRow />
          <TableRowDetail contentComponent={detailRowTemplate} />

        </Grid>
      </Paper>
    );
  }
}

RoomHistoryTable.propTypes = {
  classes: PropTypes.object.isRequired,
  rooms: PropTypes.array.isRequired,
  bookingStatus: PropTypes.array.isRequired,
  date: PropTypes.instanceOf(Date),
};

export default withStyles(styles)(RoomHistoryTable);
